import React, { useEffect, useRef } from 'react';
import embed from 'vega-embed';
import { VegaLiteChartProps } from '../../types';

export const VegaLiteChart: React.FC<VegaLiteChartProps> = ({ spec }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && spec) {
      // Yani, here is the API ref https://github.com/vega/vega-embed?tab=readme-ov-file#api-reference but basically, we just call embed with the container and spec that ARAG sends back to us.
      embed(containerRef.current, spec as any);
    }
  }, [spec]);

  return (
    <div ref={containerRef}></div>
  );
};
